import { object, string } from "yup";
import { defaultAddress, defaultContextFields, generateDateBeforeNowValidationRule, hospital, } from "../../shared.js";
const patientAccreditationStatus = string()
    .oneOf([
    "current-responsible-hospital",
    "transfer-to-responsible-hospital",
    "patient-responsible-hospital",
])
    .default(null)
    .required("Please confirm the correct option");
export const cto6Part1DataSchema = object({
    ...defaultContextFields({ userAddressOptional: true }),
    hospitalDetained: hospital,
    hospitalTransferred: hospital,
    patientAccreditationStatus: patientAccreditationStatus,
    responsibleHospital: object()
        .optional()
        .default(defaultAddress)
        .when("patientAccreditationStatus", {
        is: (value) => value === "patient-responsible-hospital",
        then: () => hospital,
        otherwise: () => object().default(defaultAddress).optional(),
    }),
}).required();
export const cto6Part2DataSchema = object({
    ...defaultContextFields({
        userAddressOptional: true,
    }),
    hospitalAdmittedTo: object({
        name: string().trim().required("Please enter hospital name"),
    })
        .nullable()
        .default({ name: "" }),
    admissionDateTime: generateDateBeforeNowValidationRule("date-time", "You cannot enter a date and/or time in the future.").required("Please enter date and time of admission to receiving hospital"),
}).required();
export const exampleCTO6Data = [
    {
        data: {
            user: {
                name: "Clinician",
                email: "david@clinician.com",
                address: "Clinician Address",
                postalCode: "ABC 123",
                isConfirmed: true,
                isSection12Approved: true,
                isApprovedClinician: true,
                isGuest: true,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            hospitalDetained: {
                isConfirmed: true,
                name: "Hospital",
                address: "Hospital Address",
                postalCode: "ABC 123",
            },
            hospitalTransferred: {
                name: "Hospital",
                address: "Hospital Address 2",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
            patientAccreditationStatus: "patient-responsible-hospital",
            responsibleHospital: {
                name: "Hospital",
                address: "Hospital Address 3",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
        },
    },
    {
        data: {
            user: {
                name: "Clinician",
                email: "david@clinician.com",
                address: "Clinician Address",
                postalCode: "ABC 123",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: true,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            hospitalAdmittedTo: {
                name: "Hospital",
            },
            admissionDateTime: "2022-07-10T12:00:00.000Z",
        },
    },
];
//# sourceMappingURL=cto6.js.map